import type { PayloadAction } from '@reduxjs/toolkit';

export function* callSagaFromAction<T>(saga: (data: T) => any, action: PayloadAction<T>) {
    yield saga(action.payload);
}
